import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Validates and converts a string value to number if it's a valid integer
 * @param value - String value to check
 * @returns Number value if valid, undefined if invalid
 */
export const validateInteger = (value: string): number | undefined => {
  if (/^\d*$/.test(value)) {
    return value === '' ? 0 : Number(value)
  }
  return undefined
}

/**
 * Validates and converts a string value to number if it's a valid decimal
 * @param value - String value to check
 * @returns Number value if valid, undefined if invalid
 */
export const validateDecimal = (value: string): number | undefined => {
  if (/^\d*\.?\d*$/.test(value)) {
    return value === '' ? 0 : Number(value)
  }
  return undefined
}

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * Email is treated as a case-insensitive identifier. Addresses are normalized before
 * being sent to the server so that the two steps of the email-code sign-in agree with
 * each other and with the stored value. Mirrors `normalizeEmail` in apps/server/utils.ts.
 */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase()
